/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyMigrationAttributes {
    COMPOSITE_DATA_CUTS = 'compositeDataCuts',
    WEIGHT = 'weight',
    ADJUSTMENT = 'adjustment',
    SURVEY_DATA_CUT_PAYMARKET_MAPPINGS = 'surveyDataCutPaymarketMappings',
}
